import { defineMessages } from 'react-intl';

export default defineMessages({
    to: {
        defaultMessage: '{portalName}',
        description: 'Statement describing where a portal request will be made to.',
        id: 'cv.search.result.request.to',
    },
});
